export default __webpack_public_path__ + "static/media/volume-up-fill.cb2b2747.svg";